import { render } from "./ListItemForm.vue?vue&type=template&id=fa2a0566&scoped=true"
import script from "./ListItemForm.vue?vue&type=script&lang=js"
export * from "./ListItemForm.vue?vue&type=script&lang=js"

import "./ListItemForm.vue?vue&type=style&index=0&id=fa2a0566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2a0566"]])

export default __exports__